import React from 'react';

import BaseNavigator from './BaseNavigator';

const MemberNavigator = () => {
  return <BaseNavigator signedIn={true} isPro={false} />;
};

export default React.memo(MemberNavigator);
